import {
    transformStatusCodeMsg
} from '@csair/emp-helpers';

let statusCodeMsg = {};
function getLangAndSwitch() {
    let language = window.sessionStorage.getItem('language');
    let isEN = language == "en";
    let isGDop = isEN ? false : window.sessionStorage.getItem('csSwitch') == 'Y';
    let isOPgd = isEN ? false : window.sessionStorage.getItem('atSwitch') == 'Y';
    let isOPzn = isEN ? false : window.sessionStorage.getItem('igSwitch') == 'Y';
    let pageInfo = {
        _lang: language ? language : "cn",
        language: language ? language : "cn"
    }
    return {
        pageInfo,
        isGDop,
        isOPgd,
        isOPzn
    }
}
export function isRefund() {
    return /\b(refundTicket)\b/.test(window.location.href);
}

export function isChange() {
    return /\b(ticketChange)\b/.test(window.location.href);
}

/**
 * 获取相应的地址
 */
export function getStatusMsgLink(code, opt) {
    let objLS = getLangAndSwitch();
    function name(ext) {
        const extFile = !ext ? `${code}.json` : `${code}.${ext}.json`;
        return `${window.location.origin}/public/apiStatusCodeMsg/${objLS.pageInfo._lang}/${extFile}`;
    }

    let arr = [name()];
    if (opt && Array.isArray(opt[code])) {
        opt[code].forEach(function (ext) {
            arr.push(name(ext));
        });
        return arr;
    }

    if (isRefund()) arr.push(name('refund'));
    if (isChange()) arr.push(name('change'));
    // if (typecr) {
    //     if (typecr = 'refundTicket') {
    //         arr.push(name('refund'));
    //     }
    //     if (typecr = 'ticketChange') {
    //         arr.push(name('change'));
    //     }
    // }
    if (window.location.href.indexOf('cancelLation') !== -1) arr.push(name('tpwl'));

    return arr;
}

/**
 * 加载API静态状态码提示信息
 * @param {array} api 接口
 * @param {object} opt 自定义后缀
 */
export function loadStatusCodeMsg(api, opt) {
    if (Array.isArray(api)) {
        api.forEach(function (_api) {
            const apiArr = getStatusMsgLink(_api, opt);
            // xhrProcessController(
            //   apiArr.map(function (address) {
            //     return function () {
            //       return loadXhrScript(address, true);
            //     };
            //   }),
            //   _api
            // );
            requestMergeCode(_api, apiArr);
        });
    }
}

export function loadXhrScript(url, async = false) {
    return window.$.ajax({
        url,
        method: 'GET',
        async,
        // dataType: 'jsonp',
        // jsonp: 'callback',
        // jsonpCallback: 'callback',
    });
}

export function requestMergeCode(apiKey, apiArr) {
    window.$.when
        .call(
            null,
            ...apiArr.map(function (api) {
                return loadXhrScript(api, true);
            })
        )
        .done(function (...args) {
            const _arr =
                apiArr.length > 1
                    ? args.map(function (item) {
                        return item[0];
                    })
                    : [args[0]];
            _arr.forEach(function (data) {
                if (!statusCodeMsg[apiKey]) {
                    statusCodeMsg[apiKey] = data;
                } else {
                    statusCodeMsg[apiKey] = {
                        ...statusCodeMsg[apiKey],
                        ...data,
                    };
                }
            });
        });
}

/**
 * 匹配状态码提示语
 * @param {string} [code='']
 * @param {*} [invalidArgs=[]]
 * @param {*} [reqConfig={}] ajax 请求配置
 * @return {string}
 */
// [1132022614001639015] [2024-10-11]
// [1132022614001601056] [2024-09-04]
export function getStatusCodeMsg(code = '', invalidArgs = [], reqConfig = {}, defaultMsg) {
    let objLS = getLangAndSwitch();
    let _url = reqConfig.url ? reqConfig.url : this.url;
    if (!_url) return '';
    // _url = new URL('http://' + _url);
    const urls = _url.split('/');
    let api = urls[urls.length - 1] || urls[urls.length - 2];
    api = api.split('?')[0];
    if (!statusCodeMsg[api] || !statusCodeMsg[api][code]) {
        return defaultMsg ? defaultMsg : '';
    }
    const msg = statusCodeMsg[api][code].indexOf("function") !== -1 ? statusCodeMsg[api][code].indexOf("znkf,GDop") !== -1 ? new Function(`return ${statusCodeMsg[api][code]}`)()(objLS.isOPzn, objLS.isGDop) : new Function(`return ${statusCodeMsg[api][code]}`)()(objLS.isOPgd) : statusCodeMsg[api][code];
    let _invalidArgs = Array.isArray(invalidArgs) ? [...invalidArgs] : [];
    return msg
        .replace(/(\${invalidArg})/g, function () {
            return _invalidArgs.shift();
        })
        .replace(/CHD/g, '');
}

/**
 * 兼容后台接口读取规则invalidCode、invalidArgs
 * @param {object} response 后台接口返参
 * @return {}
 */
export function getStatusCodeFiled(response) {
    const _response = Array.isArray(response) ? response[0] : response;
    if (!_response) {
        return {
            invalidCode: '',
            invalidArgs: [],
        };
    }

    return {
        invalidCode: _response.errorInfo ? _response.errorInfo.invalidCode : _response.error ? _response.error.errorCode : _response.invalidCode,
        invalidArgs: _response.errorInfo ? _response.errorInfo.invalidArgs : _response.error ? _response.error.invalidArgs : _response.invalidArgs,
    };
}

export function setResponseMsg3(response, reqConfig) {
    if (!response || (Array.isArray(response) && !response.length)) return response;

    const statusCode = getStatusCodeFiled(response);
    const msg = getStatusCodeMsg(statusCode.invalidCode, statusCode.invalidArgs, reqConfig);
    const result = Array.isArray(response) ? response[0] : response;

    function finProAndSetMsg(obj) {
        let objLS = getLangAndSwitch();
        let propertyChainList = ['checkMsg', 'warning', 'error.errorMsg', 'errorInfo.errorMsg', 'errorInfo.description', 'refundModeRes.error.errorMsg', 'showMsg', 'responseMessage', 'message'];
        for (let k = 0; k < propertyChainList.length; k++) {
            let isBreak = false;
            let subPropertyList = propertyChainList[k].split('.');
            let copyObj = null;
            let Num_of_copies = 0;
            for (let j = 0; j < subPropertyList.length; j++) {
                if (copyObj) {
                    if (!copyObj[subPropertyList[j]]) {
                        copyObj = null;
                        Num_of_copies = 0;
                        break;
                    }
                    if (copyObj[subPropertyList[j]] instanceof Object) {
                        Num_of_copies += 1;
                        copyObj = copyObj[subPropertyList[j]];
                    }
                }
                if (copyObj) {
                    if (typeof copyObj[subPropertyList[j]] === 'string' && j == subPropertyList.length - 1 && subPropertyList.length - 1 == Num_of_copies) {
                        isBreak = true;
                        break;
                    }
                }
                if (copyObj === null) {
                    if (!obj[subPropertyList[j]]) {
                        copyObj = null;
                        Num_of_copies = 0;
                        break;
                    }
                    if (obj[subPropertyList[j]] instanceof Object) {
                        Num_of_copies += 1;
                        copyObj = obj[subPropertyList[j]];
                    }
                }
                if (typeof obj[subPropertyList[j]] === 'string' && j == subPropertyList.length - 1 && subPropertyList.length - 1 == Num_of_copies) {
                    isBreak = true;
                    break;
                }
            }
            if (isBreak) {
                let copyObject = null;
                subPropertyList.forEach(item => {
                    if (copyObject == null) {
                        if (obj[item]) {
                            copyObject = obj[item];
                        }
                    } else {
                        if (copyObject[item] && copyObject[item] instanceof Object) {
                            copyObject = copyObject[item];
                        }
                        if (typeof copyObject[item] == 'string') {
                            copyObject[item] = msg ? transformStatusCodeMsg(msg, objLS.pageInfo.language) : transformStatusCodeMsg(copyObject[item], objLS.pageInfo.language);
                        }
                    }
                });
                if (subPropertyList.length === 1) {
                    obj[subPropertyList[0]] = msg ? transformStatusCodeMsg(msg, objLS.pageInfo.language) : transformStatusCodeMsg(obj[subPropertyList[0]], objLS.pageInfo.language);
                }
                break;
            }
        }
    }
    finProAndSetMsg(result);
    if (Array.isArray(response)) return [result];

    return result;
}




// WEBPACK FOOTER //
// ./src/utils/enEXchange.js